export const __dev__ =
  process.env.NODE_ENV === "development" ||
  process.env.NEXT_PUBLIC_VERCEL_ENV === "development";
export const __preview__ = process.env.NEXT_PUBLIC_VERCEL_ENV === "preview";
const __prod__ = !__dev__ && !__preview__;

export function isDefined<T>(argument: T | undefined): argument is T {
  return argument !== undefined;
}

function isValueInEnum<T extends object>(
  value: string | number | T[keyof T],
  enumType: T
): value is T[keyof T] {
  return Object.values(enumType).includes(value as T[keyof T]);
}

export interface MDXRichText {
  type: "root";
  children: Paragraph[];
}

export interface Paragraph {
  type: "p";
  children: TextNode[];
}

interface TextNode {
  type: "text";
  text: string;
}
